// Utility function to generate headers
import axios from "./axios";

function getHeaders(authContext) {
    return {
      Authorization: `Bearer ${authContext.authToken}`,
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    };
  }
  
  // Utility function to handle API requests
  export async function apiRequest(method, url, authContext, data = null) {
    const result = {};
    if (!authContext) {
      result.isSuccess = false;
      result.data = "Authentication context is missing";
      return result;
    }
  
    try {
      const response = await axios({
        method,
        url,
        headers: getHeaders(authContext),
        data,
      });
      result.isSuccess = true;
      result.data = response?.data;
    } catch (error) {
      result.isSuccess = false;
      result.data = error?.response?.data || "An error occurred";
    }
  
    return result;
  }